import { Component, OnInit, ViewChild } from "@angular/core";
import { BaseUpdateComponent, BaseDataService, NotificationService, ConfirmationDialogButtons, ModalService } from "yt-ng-framework";
import { Roba } from "./roba";
import { ActivatedRoute } from "@angular/router";
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from "angular2-notifications";
import { Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
// import { ToastrService } from "ngx-toastr";

@Component({
  selector: "yt-roba-update",
  templateUrl: "./roba-update.component.html"
})
export class RobaUpdateComponent extends BaseUpdateComponent<Roba>
  implements OnInit {
  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) {
    super(
      activatedRoute,
      baseDataService,
      toastrService,
      translateService
    );
  }

  @ViewChild('tabSet', { static: true }) tabset: any;

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc(
      "Sifra",
      Validators.required,
      "required",
      "ROBA.SIFRA.VALIDATION.REQUIRED"
    );
    this.addValidatorToFc(
      "Sifra",
      Validators.maxLength(13),
      "maxlength",
      "ROBA.SIFRA.VALIDATION.MAXLENGTH"
    );
    // this.addValidatorToFc("Barcode", Validators.required, 'required', 'ROBA.BARCODE.VALIDATION.REQUIRED');
    this.addValidatorToFc(
      "Barcode",
      Validators.maxLength(13),
      "maxlength",
      "ROBA.BARCODE.VALIDATION.MAXLENGTH"
    );
    this.addValidatorToFc(
      "Naziv",
      Validators.required,
      "required",
      "ROBA.NAZIV.VALIDATION.REQUIRED"
    );
    this.addValidatorToFc(
      "Naziv",
      Validators.maxLength(200),
      "maxlength",
      "ROBA.NAZIV.VALIDATION.MAXLENGTH"
    );
    this.addValidatorToFc(
      "RobnaGrupaID",
      Validators.required,
      "required",
      "ROBA.ROBNAGRUPAID.VALIDATION.REQUIRED"
    );
    // this.addValidatorToFc("TarifaID", Validators.required, 'required', 'ROBA.TARIFAID.VALIDATION.REQUIRED');
    this.addValidatorToFc(
      "UnitOfMeasureID",
      Validators.required,
      "required",
      "ROBA.UNITOFMEASUREID.VALIDATION.REQUIRED"
    );
    // this.addValidatorToFc("AltUnitOfMeasureID", Validators.required, 'required', 'ROBA.ALTUNITOFMEASUREID.VALIDATION.REQUIRED');
    // this.addValidatorToFc("JmOdnos", Validators.required, 'required', 'ROBA.JMODNOS.VALIDATION.REQUIRED');
   
  }

  SaveItem(): Promise<any> {
  return super.SaveItem()
    .catch(error => {
      this.submitted = false;
      this.SaveProcessed.emit(true);

      this.modalService.ShowConfirmationDialog("Upozorenje",error.error, "warning",ConfirmationDialogButtons.Ok)
    });
  }
}
